import React, { useRef, Fragment, useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useRequireAuth from "../../utils/useRequireAuth";
import SearchGrey from "../../assets/images/icons/SearchGrey.svg";
import { ReactComponent as CloseModalImg } from "../../assets/images/Vector.svg";
import active from "../../assets/images/doctype.svg";
import useSortableContent from "../../hooks/Content/useSortableContent";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import { getUserToken, returnWholeData } from "../../utils/utilityFunctions/localServices";
import { pushAlert } from "../../utils/alertSlice";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { useFetchCustomerActivityQuery, usePostCustomerActivityMutation } from "../../utils/customer/customerSelect";

const formatchangeDateformate = (dateString) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const parts = dateString.split("-");
  const day = parseInt(parts[0], 10);
  const monthIndex = parseInt(parts[1], 10) - 1;
  const year = parts[2].split(" ");
  const formattedDate = `${day} ${monthNames[monthIndex]} ${year[0].slice(-2)}  ${year[1]}`;
  return formattedDate;
};

const highlightTextInHtml = (html, highlight) => {
  if (!highlight.trim()) return html;

  const regex = new RegExp(`(${highlight})`, "gi");
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
  let node;
  while ((node = walker.nextNode())) {
    const text = node.textContent;
    if (regex.test(text)) {
      const span = document.createElement("span");
      span.innerHTML = text.replace(regex, (match) => `<span class="bg-yellow-300">${match}</span>`);
      node.replaceWith(span);
    }
  }

  // Ensure you return the HTML content as a string
  return tempDiv.innerHTML;
};

const formatTextWithLineBreaks = (text) => {
  return text.replace(/\n/g, "<br />"); // Convert line breaks to HTML <br /> tags
};

const PararagraphComponent = ({ CategoryData, searchTerm }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const paragraphRef = useRef(null);

  useEffect(() => {
    // Check if the paragraph's height exceeds the height of 3 lines
    const checkHeight = () => {
      if (paragraphRef.current) {
        const { scrollHeight, clientHeight } = paragraphRef.current;
        setShowReadMore(scrollHeight > clientHeight);
      }
    };

    // Initial check when component mounts
    checkHeight();

    // Check again when window is resized
    window.addEventListener("resize", checkHeight);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", checkHeight);
  }, [CategoryData.description]);

  const handleReadMoreClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="space-y-2">
      <p
        ref={paragraphRef}
        className={`text-sm font-medium text-justify text-[#383838] break-words ${
          isExpanded ? "line-clamp-none" : "line-clamp-3"
        }`}
        dangerouslySetInnerHTML={{
          __html: highlightTextInHtml(formatTextWithLineBreaks(CategoryData), searchTerm),
        }}
      ></p>

      {showReadMore && (
        <button
          className="text-blue-500 hover:text-blue-600 font-300 text-xs cursor-pointer"
          onClick={handleReadMoreClick}
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

const CustomerEditTaskActivity = ({
  onFocus,
  activityid,
  taskCategory,
  activity,
  onBlur,
  cross,
  showNotification,
  handleNotification,
  withDrawer,
  open,
  onClose,
  item,
  type,
  parallelDrawer,
}) => {
  console.log("talib56985", activityid);

  const chatContainer = useRef();

  const location = useLocation();
  const [editTaskSearchInput, setEditTaskSearchInput] = useState("");
  const scrollRef = useRef(null);

  const [description, setDescription] = useState("");
  const handleInputChange = (event) => {
    const { value } = event.target;
    setDescription(value);
  };
  const [taskEvent, setTaskEvent] = useState([]);
  const activitys = useSelector((state) => state.activity);
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(null);

  const { data: ActivityData, refetch: refetchActivity } = useFetchCustomerActivityQuery({
    token: token,
    activityid: activityid,
    type: type,
  });

  console.log(ActivityData, "ActivityData");

  const [postActivity] = usePostCustomerActivityMutation();

  useEffect(() => {
    if (ActivityData) {
      setTaskEvent(ActivityData?.data);
      setTimeout(() => {
        updateScroll();
      }, 500);
    }
  }, [ActivityData]);

  useLayoutEffect(() => {
    if (ActivityData) {
      setTimeout(() => {
        updateScroll();
      }, 500);
    }
    // return()
  }, [ActivityData]);

  function updateScroll() {
    if (chatContainer.current) {
      chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
    }
  }

  const [isActivityModalOpen, setActivityModalOpen] = useState(true);
  const closeActivityModal = () => {
    setActivityModalOpen(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sortedData, sortData, sortKey, sortOrder, handleSearch } = useSortableContent(taskEvent, "asc");

  const handleSubmitButtonClick = async (e) => {
    try {
      if (description.length < 1) {
        return dispatch(
          pushAlert({
            visible: true,
            message: "Text cannot be empty.",
            type: "danger",
          })
        );
      } else {
        let result = await postActivity({
          token: getUserToken(),
          data: { activity_id: activityid, description: description, type: type },
        });
        if (result?.data.success) {
          refetchActivity();
          dispatch(
            pushAlert({
              visible: true,
              message: "Data Updated Successfully",
              type: "success",
            })
          );
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: "Data Entry Error jk",
              type: "danger",
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }

    setDescription("");
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [sortedData]);

  const formatTextWithLineBreaks = (text) => {
    return text.replace(/\n/g, "<br />"); // Convert line breaks to HTML <br /> tags
  };

  const shouldHideParagraph = location.pathname.includes("/customer");

  const filterActivity = sortedData?.filter(
    (activity) =>
      activity.created_by?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      activity.description?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const name = returnWholeData();
  const toggleSearchIcon = () => {
    setIsSearchActive((prevState) => !prevState);
  };
  const ClearSearchInput = () => {
    if (searchTerm) {
      setSearchTerm("");
    }
  };

  return (
    <CustomDrawer open={open} onClose={onClose} parallelDrawer={parallelDrawer}>
      <div className="flex justify-between w-full items-center bg-[#FFFFFF] border-b-2 py-2 px-3">
        <div className="flex items-center grow min-w-0">
          <img src={active} alt="Doctype Icon" className="w-6 h-6 font-semibold text-gray-500 gap-2" />
          <i className="bi bi-circle-fill text-D93916 relative top-[-0.714rem]  due-info">
            <span
              onClick={openModal}
              className="text-white text-[0.666rem] font-400 absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center"
            >
              {taskEvent?.length}
            </span>
          </i>
          <div className="text-[#203C50] flex flex-col min-w-0 grow font-semibold text-base font-poppins ml-3 ">
            <div className="text-nowrap truncate">{item?.customer_name}</div>
            <span className="text-[#3C3C3C99] text-nowrap truncate flex flex-row text-sm font-poppins font-400">
              {item?.subject}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <div className="flex items-center mr-3">
            {isSearchActive && (
              <div className="flex item-centre justify-center">
                <input
                  value={searchTerm}
                  className="b-1 max-w-[10rem] border-gray-300 rounded-md pr-[2rem]"
                  type="text"
                  placeholder="Search Activity..."
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm ? (
                  <CloseModalImg
                    className="w-2 h-2 relative text-grey-300 top-[0.8rem] left-[-1.42rem] cursor-pointer"
                    onClick={ClearSearchInput}
                  />
                ) : (
                  <span
                    className="w-2 h-2 relative text-grey-300 top-[0.8rem] left-[-1.42rem] cursor-pointer"
                    onClick={ClearSearchInput}
                  />
                )}
              </div>
            )}

            <button
              onClick={toggleSearchIcon}
              type="button"
              className="text-[#B9B9B9] bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-4 h-8 end-0 items-center"
              data-modal-hide="assets-modal"
            >
              <img src={SearchGrey} alt="Search Icon" />
            </button>
          </div>

          <button
            onClick={onClose}
            type="button"
            className="text-[#B9B9B9] bg-transparent hover:bg-F1F5F8 rounded-lg text-base"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only flex float-end">Close modal</span>
          </button>
        </div>
      </div>

      {!shouldHideParagraph && (
        <p className=" text-16 text-60A2C2 font-600 mt-3 ms-2 capitalize">{item?.customer_name?.value}</p>
      )}
      <div className="flex flex-col flex-1 overflow-y-auto addTask w-full mb-1 px-3 pt-2" ref={chatContainer}>
        <p className="mb-1">{taskCategory}</p>

        {/* -------------------------------------------------------------------------------- */}
        {!filterActivity
          ? null
          : filterActivity.map((CategoryData, index) => {
              console.log("CategoryData", CategoryData);

              const initials = (CategoryData?.created_by || "")
                ?.split(" ")
                .filter((word) => word.length > 0)
                .map((word) => word.charAt(0).toUpperCase())
                .slice(0, 2)
                .join("");

              return (
                <div key={CategoryData.id} className="flex flex-col rounded-md w-full">
                  <div className="flex items-start gap-2">
                    {CategoryData.created_by !== name?.name && (
                      <div className="h-7 w-7 flex items-center justify-center rounded-full">
                        <span className="text-xs text-white">
                          <strong className="text-11 font-500 text-6C7281 cursor-pointer">
                            <Tooltip
                              title={
                                <>
                                  <div className="py-2 min-w-[17.78rem]">
                                    <div className="rounded-lg bg-white">
                                      <div className="border-b-2 space-y-2 pb-2">
                                        <div className="flex px-2 space-x-2">
                                          <div>
                                            <div
                                              className="w-7 h-7 rounded-full flex justify-center items-center text-white text-xs"
                                              style={{ backgroundColor: CategoryData.c_key }}
                                            >
                                              {initials}
                                            </div>
                                          </div>
                                          <div className="text-2999BC text-14">{CategoryData?.created_by || "-"}</div>
                                        </div>

                                        <div className="flex px-2 space-x-2 my-2">
                                          <div className="w-5 text-center">
                                            <i className="bi bi-envelope bi-xl"></i>
                                          </div>
                                          <div className="text-F16136 text-12">{CategoryData?.email || "-"}</div>
                                        </div>

                                        <div className="flex px-2 space-x-2 my-2">
                                          <div className="w-5 text-center">
                                            <i className="bi bi-telephone bi-xl"></i>
                                          </div>
                                          <div className="text-F16136 text-12">{CategoryData?.phone || "-"}</div>
                                        </div>
                                      </div>
                                      <div className="flex justify-end mt-2 me-5 text-12">
                                        <button className="text-blue-500">Show more</button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              }
                              PopperProps={{ style: { zIndex: 99999 } }}
                              placement="top"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "common.white",
                                    filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                    color: "#383838",
                                    "& .MuiTooltip-arrow": {
                                      color: "common.white",
                                      filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                    },
                                  },
                                },
                              }}
                            >
                              <div
                                className={`text-white text-12 font-600 w-7 h-7 flex items-center justify-center rounded-full ${
                                  CategoryData.created_by === filterActivity[index - 1]?.created_by
                                    ? "invisible"
                                    : "visible"
                                }`}
                                style={{ backgroundColor: CategoryData.c_key }}
                              >
                                {initials}
                              </div>
                            </Tooltip>
                          </strong>
                        </span>
                      </div>
                    )}

                    <div
                      className={`flex flex-col ${CategoryData.created_by === name?.name ? "items-end" : "items-start "} flex-1`}
                    >
                      <div className="w-[18rem] mb-2">
                        <div
                          className={`border border-DEE0E2 bg-[#E8E8E8] px-3 overflow-hidden h-full py-2 w-[18rem] ${
                            CategoryData.created_by === name?.name
                              ? "ml-auto  bg-[#E8E8E8]  rounded-br-[1rem] rounded-tl-[1rem] rounded-bl-[1rem]"
                              : "mr-auto  bg-[#EBF2F6] rounded-br-[1rem] rounded-tr-[1rem] rounded-bl-[1rem]"
                          }`}
                        >
                          <PararagraphComponent CategoryData={CategoryData.description} searchTerm={searchTerm} />
                        </div>
                        <span
                          className={`text-[#393939]  font-300 text-10 ${CategoryData.created_by === name?.name ? "ml-1" : "mr-auto"} mt-1 gap-3 pb-2`}
                        >
                          {CategoryData.created_at}
                        </span>
                      </div>
                    </div>

                    {CategoryData.created_by === name?.name && (
                      <div className="h-7 w-7 flex items-center justify-center rounded-full">
                        <span className="text-xs text-white">
                          <strong className="text-11 font-500 text-6C7281 cursor-pointer">
                            <Tooltip
                              title={
                                <>
                                  <div className="py-2 min-w-[17.78rem]">
                                    <div className="rounded-lg bg-white">
                                      <div className="border-b-2 space-y-2 pb-2">
                                        <div className="flex px-2 space-x-2">
                                          <div>
                                            <div
                                              className="w-7 h-7 rounded-full flex justify-center items-center text-white text-xs"
                                              style={{ backgroundColor: CategoryData.c_key }}
                                            >
                                              {initials}
                                            </div>
                                          </div>
                                          <div className="text-2999BC text-14">{CategoryData?.created_by || "-"}</div>
                                        </div>

                                        <div className="flex px-2 space-x-2 my-2">
                                          <div className="w-5 text-center">
                                            <i className="bi bi-envelope bi-xl"></i>
                                          </div>
                                          <div className="text-F16136 text-12">{CategoryData?.email || "-"}</div>
                                        </div>

                                        <div className="flex px-2 space-x-2 my-2">
                                          <div className="w-5 text-center">
                                            <i className="bi bi-telephone bi-xl"></i>
                                          </div>
                                          <div className="text-F16136 text-12">{CategoryData?.phone || "-"}</div>
                                        </div>
                                      </div>
                                      <div className="flex justify-end mt-2 me-5 text-12">
                                        <button className="text-blue-500">Show more</button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              }
                              PopperProps={{ style: { zIndex: 99999 } }}
                              placement="top"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "common.white",
                                    filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                    color: "#383838",
                                    "& .MuiTooltip-arrow": {
                                      color: "common.white",
                                      filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                    },
                                  },
                                },
                              }}
                            >
                              <div
                                className={`text-white text-12 font-600 w-7 h-7 flex items-center justify-center rounded-full ${
                                  CategoryData.created_by === filterActivity[index - 1]?.created_by
                                    ? "invisible"
                                    : "visible"
                                }`}
                                style={{ backgroundColor: CategoryData.c_key }}
                              >
                                {initials}
                              </div>
                            </Tooltip>
                          </strong>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
      </div>

      <div className="border-none bg-white flex items-center w-full px-3 pb-2">
        {/* Input with Send Button */}
        <div className="flex items-center justify-between w-full border border-gray-300 rounded-md">
          <div className="flex grow min-w-0 items-center justify-between">
            {/* <img src={Active2} alt="Active Icon" className="w-5 h-5 ml-3 mr-1 text-gray-500 cursor-pointer" /> */}
            <input
              type="text"
              className="w-full text-lg text-gray-900 bg-white border-0 rounded-md focus:outline-none focus:ring-0 focus:border-0 "
              placeholder="Type Something..."
              value={description}
              onChange={handleInputChange}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          <div className="flex items-center justify-between">
            {/* <img src={Smile} alt="Smile Icon" className="mx-2 cursor-pointer" /> */}
            <button
              className=" my-1 mr-2 right-0 px-7 py-1.5 text-white bg-[#123251] rounded-lg hover:bg-blue-600 focus:outline-none"
              onClick={handleSubmitButtonClick}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};
export default CustomerEditTaskActivity;
